import React, { useContext, useRef } from 'react';
import { IVideosContext, VideosContext } from '../../../videosState/videosContext';
import Text from 'components/Text/Text';
import { IGetVideoCategoriesShort } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import { getVideoCategoriesShortInfo } from 'backend/videos';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { useTranslation } from 'react-i18next';
import style from './CategorySelect.module.scss';

const { Option } = Select;

const CategorySelect: React.FC = () => {
	const { setCategory, selectedCategory } = useContext<IVideosContext>(VideosContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetVideoCategoriesShort, void>(
		getVideoCategoriesShortInfo,
	);
	const { t } = useTranslation('listing');

	const value = !loading ? selectedCategory : undefined;

	return (
		<div className={style.container} data-test="CategorySelect">
			<Text translationNameSpace="listing" translationKey="categoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setCategory}
				value={value}
				loading={loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				allowClear={true}
				removeIcon={false}
				listItemHeight={response?.data.videoCategories.length}
				placeholder={t('selectPlaceholder')}>
				<>
					<Option className={style.disabledItem} value="empty" disabled={true}>
						<Text
							translationNameSpace="listing"
							translationKey="selectAnyItemPlaceholder"
							asFragment={true}
						/>
					</Option>
					{response?.data.videoCategories.map((el) => (
						<Option className={style.listItem} value={el.id} key={el.id}>
							{el.name}
						</Option>
					))}
				</>
			</Select>
		</div>
	);
};

export default CategorySelect;
